// extracted by mini-css-extract-plugin
module.exports = {"ErrorText":"Components_ErrorText__2Z8sX"};